import type { HTTPTransaction } from '@carboncopyco/types';
import { DropdownFilter, type DropdownFilterProps } from '@carboncopyco/ui';
import { isEmpty } from 'lodash-es';

export type TransactionContent =
  | 'requestBody'
  | 'requestHeaders'
  | 'responseBody'
  | 'responseHeaders';

export type TransactionContentFilterProps = Pick<
  DropdownFilterProps<TransactionContent>,
  'items' | 'selected' | 'onSelect'
>;
export const transactionContentToLabel: Record<TransactionContent, string> = {
  requestBody: 'Request Body',
  requestHeaders: 'Request Headers',
  responseBody: 'Response Body',
  responseHeaders: 'Response Headers',
};

export const getFilterOptions = (
  transaction: HTTPTransaction
): TransactionContentFilterProps['items'] => [
  {
    id: 'responseBody',
    label: transactionContentToLabel.responseBody,
    disabled: !transaction.response.body,
  },
  {
    id: 'responseHeaders',
    label: transactionContentToLabel.responseHeaders,
    disabled: isEmpty(transaction.response.headers),
  },
  {
    id: 'requestBody',
    label: transactionContentToLabel.requestBody,
    disabled: !transaction.request.body,
  },
  {
    id: 'requestHeaders',
    label: transactionContentToLabel.requestHeaders,
    disabled: isEmpty(transaction.request.headers),
  },
];

export const TransactionContentFilter = ({
  items,
  selected,
  onSelect,
}: TransactionContentFilterProps) => (
  <DropdownFilter<TransactionContent>
    size="small"
    placeholder="Content"
    items={items}
    onSelect={onSelect}
    selected={selected}
    contentWidth={200}
  />
);
